/**
 * Theme-aware FLOSTEL company lockup (horizontal), from
 * frontend/public/flostel-logo-horizontal-{light,dark}.svg. Keep all visual
 * changes to those files.
 *
 * Both variants render; Tailwind visibility toggles show exactly one
 * (`dark:hidden` / `hidden dark:block`). No JS theme reads — no flash on
 * load and no ThemeProvider dependency. Only one is ever in the
 * accessibility tree (`display: none` removes the other), so both carry
 * the same alt text.
 *
 * `variant` forces one lockup on surfaces whose background ignores the
 * theme — the sign-in hero is dark teal in both modes, so it always
 * takes the dark-background (light wordmark) art.
 *
 * Used for the "developed by" credit. For the product mark, see Logo.tsx.
 */
export default function FlostelLogo({
  className = '',
  variant = 'auto',
}: {
  className?: string
  variant?: 'auto' | 'light' | 'dark'
}) {
  if (variant === 'light') {
    return (
      <img
        src="/flostel-logo-horizontal-light.svg"
        alt="FLOSTEL"
        className={className}
        draggable={false}
      />
    )
  }
  if (variant === 'dark') {
    return (
      <img
        src="/flostel-logo-horizontal-dark.svg"
        alt="FLOSTEL"
        className={className}
        draggable={false}
      />
    )
  }
  return (
    <>
      <img
        src="/flostel-logo-horizontal-light.svg"
        alt="FLOSTEL"
        className={`${className} dark:hidden`}
        draggable={false}
      />
      <img
        src="/flostel-logo-horizontal-dark.svg"
        alt="FLOSTEL"
        className={`${className} hidden dark:block`}
        draggable={false}
      />
    </>
  )
}
